<template>
  <Layout>
    <PageHeader
      :items="items"
    />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">{{ title }}</span>
        <span>
          <!-- <button
            size="sm"
            class="p-0 ml-2 btn-link-add"
            @click.prevent="openCreateUpdateModal(null, null, 'create')"
          >
            Crear
            <b-icon
              class="icon-plus"
              icon="plus-circle-fill"
            ></b-icon>
          </button> -->
        </span>
      </div>
      <div class="card-app">
        <b-row>
          <b-col class="p-0 m-0">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template #head(actions)>
                <span class="title-actions d-flex justify-content-center">Acciones</span>
                <div class="d-flex content-actions">
                  <span>Información</span>
                  <span>Editar</span>
                  <span>Cambiar</span>
                  <span>Eliminar</span>
                </div>
              </template>
              <template v-slot:cell(username)="data">
                {{ data.value }}
              </template>
              <template v-slot:cell(first_name)="data">
                {{ data.value.charAt(0).toUpperCase() + data.value.slice(1) }}
                {{
                  data.item.last_name.charAt(0).toUpperCase() +
                    data.item.last_name.slice(1)
                }}
              </template>
              <!-- <template v-slot:cell(is_staff)="data">
                <i v-if="data.value" class="fe-check-circle" style="color: green"></i>
                <i v-if="!data.value" class="fe-x-circle" style="color: red"></i>
              </template> -->

              <template v-slot:cell(is_superuser)="data">
                <i
                  v-if="data.value"
                  class="fe-check-circle"
                  style="color: green"
                ></i>
                <i
                  v-if="!data.value"
                  class="fe-x-circle"
                  style="color: red"
                ></i>
              </template>

              <template v-slot:cell(is_active)="data">
                <i
                  v-if="data.value"
                  class="fe-check-circle"
                  style="color: green"
                ></i>
                <i
                  v-if="!data.value"
                  class="fe-x-circle"
                  style="color: red"
                ></i>
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group size="xs" class="d-flex">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    :disabled="
                      isSubmitting || actionsLoadings[`info-btn-${row.index}`]
                    "
                    @click="
                      openDetailModal(
                        row.item,
                        row.index,
                        `info-btn-${row.index}`
                      )
                    "
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fe-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>

                  <b-button
                    :id="`update-btn-${row.index}`"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    :disabled="isSubmitting"
                    @click="
                      openCreateUpdateModal(row.item, row.index, 'update')
                    "
                  >
                    <b-icon-pencil></b-icon-pencil>
                  </b-button>

                  <b-button
                    :id="`update-pw-btn-${row.index}`"
                    variant="btn-link btn-hover text-info btn-transparent"
                    size="xs"
                    :disabled="isSubmitting"
                    @click="
                      openCreateUpdateModal(
                        row.item,
                        row.index,
                        'password_change'
                      )
                    "
                  >
                    <i class="fe-lock fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    variant="outline-danger btn-transparent"
                    size="xs"
                    :disabled="isSubmitting"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <b-icon-trash></b-icon-trash>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Detail modal -->
    <b-modal
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
    >
      <!--{{detailModal.content}}-->
      <table>
        <tr>
          <td width="140px">
            <img
              id="image_avatar"
              class="user-image"
              :src="detailModal.photo"
              :onerror="
                `this.onerror=null;this.src='${require('@assets/images/users/avatar-clear.png')}';`
              "
            />
          </td>
          <td>
            <b>Username</b> {{ detailModal.content.username }}<br />
            <b>Name</b> {{ detailModal.content.first_name }}
            {{ detailModal.content.last_name }}<br />
            <b>Email</b> {{ detailModal.content.email }}<br />
            <b>Is superuser? </b>{{ detailModal.content.is_superuser }}<br />
            <b>Subscribed to email notifications ? </b
            >{{
              detailModal.content.user_info
                ? detailModal.content.user_info.email_subscription
                : ''
            }}<br />
            <b>Is API user ? </b
            >{{
              detailModal.content.user_info
                ? detailModal.content.user_info.is_api_user
                : ''
            }}<br />
            <b>Is active?</b> {{ detailModal.content.is_active }}<br />
            <h5 v-if="detailModal.content.groups_detail">Groups</h5>
            <ul>
              <li
                v-for="(groups, index) in detailModal.content.groups_detail"
                :key="index"
              >
                {{ _.capitalize(groups.name) }}
              </li>
            </ul>
            <h5 v-if="detailModal.content.app_user_permissions_detail"
              >Permissions</h5
            >
            <ul>
              <li
                v-for="(permission, index) in detailModal.content
                  .app_user_permissions_detail"
                :key="index"
              >
                {{ _.capitalize(permission.permission.name) }}
              </li>
            </ul>

            <h5 v-if="detailModal.content.app_sections_tree">Sections</h5>
            <ul>
              <li
                v-for="(section, index) in detailModal.content
                  .app_sections_tree"
                :key="index"
              >
                {{ section.name }}
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </b-modal>

    <!-- Create-Update modal -->
    <b-modal
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' || action === 'password_change' ? 'sm' : 'lg'"
    >
      <UsersUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :onphotosubmit="onPhotoSubmit"
        :form="updateForm"
      >
      </UsersUpdateForm>
      <UsersCreateForm
        v-if="action === 'create'"
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm"
      >
      </UsersCreateForm>
      <UsersUpdatePwForm
        v-if="action === 'password_change'"
        :validator="$v.updatePwForm"
        :onformsubmit="onFormSubmit"
        :form="updatePwForm"
      >
      </UsersUpdatePwForm>
      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary"
          pill
          size="sm"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          Cancelar
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          pill
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : action === 'update'
              ? $v.updateForm.$invalid || isSubmitting
              : $v.updatePwForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t('submit') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Eliminar usuario"
      ok-title="Delete"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteUser"
    >
      <p>
        Está seguro que desea eliminar al usuario llamado
        <b>{{ toDelete.username }}</b> ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-primary" pill @click="cancel">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          pill
          :disabled="isSubmitting"
          @click="ok"
        >
          <span v-if="!isSubmitting">
            {{ $t('delete') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import UsersUpdateForm from '@views/roles_management/users/update-form'
import UsersCreateForm from '@views/roles_management/users/create-form'
import UsersUpdatePwForm from '@views/roles_management/users/update-pw-form'
import { usersMethods, authComputed } from '@state/helpers'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {
  page: {
    title: 'Usuarios',
    meta: [{ name: 'Users management', content: 'Users management' }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    UsersCreateForm,
    UsersUpdateForm,
    UsersUpdatePwForm,
  },
  data() {
    return {
      title: 'Usuarios',
      users: {},
      tableHeaders: [
        {
          key: 'username',
          label: 'Usuario',
          sortable: true,
        },
        {
          key: 'first_name',
          label: 'Nombre',
          sortable: true,
        },
        {
          key: 'email',
          sortable: true,
        },
        // {
        //   key: 'is_staff',
        //   label: 'Staff?',
        //   sortable: true
        // },
        {
          key: 'is_superuser',
          label: 'Superusuario',
          sortable: true,
        },
        {
          key: 'is_active',
          label: 'Activo',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false,
        },
      ],
      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
        photo: '',
      },
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
        content: '',
      },
      createForm: {
        username: '',
        password: '',
        repeat_password: '',
        app_sections_users: [],
      },
      updateForm: {
        url: '',
        username: '',
        first_name: '',
        last_name: '',
        email: '',
        // is_staff: false,
        is_superuser: false,
        is_active: true,
        is_api_user: true,
        email_subscription: true,
        user_info: {
          secretaries: [],
          privacy_level: 1,
        },
        groups: [],
        user_permissions: [],
        privacy_level: 1,
        secretaries: [],
        app_sections_users: [],
      },
      updatePwForm: {
        url: '',
        password: '',
        repeat_password: '',
      },
      action: '',
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      items: [
        { text: '/', path: '/home', to: { name: 'home' } },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
      extraButtons: [
        {
          variant: 'info',
          title: 'Crear nuevo usuario',
          label: 'Agregar',
          to: { name: 'form' },
          function: true,
          icon: 'plus-circle-fill',
        },
      ],
    }
  },
  validations: {
    updateForm: {
      username: {
        required,
        minLength: minLength(4),
      },
      email: { email },
      first_name: {},
      last_name: {},
    },
    createForm: {
      username: {
        required,
        minLength: minLength(4),
      },
      password: {
        required,
        minLength: minLength(4),
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
    updatePwForm: {
      password: {
        required,
        minLength: minLength(4),
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...usersMethods,

    myProvider(ctx) {
      const promise = this.fetchUsers(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          return []
        })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `User: ${item.username}`
      const promise = context.fetchUsersDetail(item.url)
      return promise
        .then((data) => {
          context.detailModal.content = data
          context.detailModal.photo =
            data.user_info && data.user_info.photo
              ? data.user_info.photo
              : require('@assets/images/users/avatar-clear.png')
          context.detailModalShow = !context.detailModalShow
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create') {
        this.action = 'create'
        this.createUpdateModal.title = `Nuevo Usuario`
      } else if (action === 'update') {
        this.action = 'update'
        this.createUpdateModal.title = `Actualizar Usuario`
        this.createUpdateModal.content = JSON.stringify(item, null, 2)
        this.updateForm.url = item.url
        this.updateForm.username = item.username
        this.updateForm.first_name = item.first_name
        this.updateForm.last_name = item.last_name
        this.updateForm.email = item.email
        // this.updateForm.is_staff = item.is_staff
        this.updateForm.is_superuser = item.is_superuser
        this.updateForm.is_active = item.is_active
        this.updateForm.user_permissions = item.user_permissions_filtered
        this.updateForm.groups = item.groups
        this.updateForm.user_info = item.user_info
        this.updateForm.is_api_user = item.user_info
          ? item.user_info.is_api_user
          : false
        this.updateForm.email_subscription = item.user_info
          ? item.user_info.email_subscription
          : false
        // this.updateForm.privacy_level = item.user_info ? item.user_info.privacy_level : this.updateForm.privacy_level
        // this.updateForm.secretaries = item.user_info ? item.user_info.secretaries != null ? item.user_info.secretaries : [] :this.updateForm.secretaries
        this.updateForm.app_sections_users = item.app_sections_users
      } else {
        this.action = 'password_change'
        this.createUpdateModal.title = `Contraseña ${item.username}`
        this.updatePwForm.url = item.url
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },
    deleteUser() {
      let context = this
      context.isSubmitting = true
      let reservedUsers = [
        getSecret('APP_API_USERNAME'),
        context.currentSession.user.username,
      ]
      if (!reservedUsers.includes(context.toDelete.username)) {
        const promise = context.deleteUsers(context.toDelete.url)
        return promise
          .then((data) => {
            context.$generate_toast(
              context,
              'success',
              'User deleted successfully'
            )
            context.$refs.table.refresh()
            context.isSubmitting = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.isSubmitting = false
          })
      } else {
        context.$generate_toast(
          context,
          'error',
          'This user cannot be deleted because is protected or is yourself'
        )
        context.isSubmitting = false
      }
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      this.createUpdateModal.content = ''
      if (action === 'create') {
        this.createForm.username = ''
        this.createForm.password = ''
        this.createForm.repeat_password = ''
        this.createForm.app_sections_users = []
        this.$v.createForm.$reset()
      } else if (action === 'update') {
        this.updateForm.url = ''
        this.updateForm.username = ''
        this.updateForm.first_name = ''
        this.updateForm.last_name = ''
        this.updateForm.email = ''
        // this.updateForm.is_staff = false
        this.updateForm.is_superuser = false
        this.updateForm.email_subscription = true
        this.updateForm.is_api_user = false
        this.updateForm.is_active = true
        this.updateForm.user_permissions = []
        this.updateForm.groups = []
        this.updateForm.app_sections_users = []
        this.updateForm.privacy_level = 1
        this.updateForm.secretaries = []
        this.$v.updateForm.$reset()
      } else {
        this.updatePwForm.url = ''
        this.updatePwForm.password = ''
        this.updatePwForm.repeat_password = ''
      }
    },
    onFormSubmit(evt) {
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.updateForm.$anyError) {
        context.$v.updateForm.$touch()
      }
      context.updateForm.privacy_level =
        context.updateForm.user_info.privacy_level
      context.updateForm.secretaries = context.updateForm.user_info.secretaries

      let form =
        context.action === 'create'
          ? context.createForm
          : context.action === 'update'
          ? context.updateForm
          : context.updatePwForm
      const promise =
        context.action === 'password_change'
          ? context.changePassword(form)
          : context.createUpdateUsers(form)
      return promise
        .then((data) => {
          if (context.action === 'create') {
            context.$generate_toast(
              context,
              'success',
              'Usuario creado exitosamente'
            )
          } else if (context.action === 'update') {
            context.$generate_toast(
              context,
              'success',
              'Usuario actualizado exitosamente'
            )
            if (context.currentSession.user.username === form.username) {
              this.$store.dispatch('auth/validate', true)
            }
          } else {
            context.$generate_toast(
              context,
              'success',
              'Contraseña actualizada exitosamente'
            )
          }
          context.createUpdateModalShow = !context.createUpdateModalShow
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
    async onPhotoSubmit(formData) {
      let context = this
      context.isSubmitting = true
      formData.append('url', context.updateForm.url)
      return context
        .updatePhotos(formData)
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            'Avatar actualizado exitosamente'
          )
          context.isSubmitting = false
          context.$refs.table.refresh()
          if (
            context.currentSession.user.username === context.updateForm.username
          ) {
            this.$store.dispatch('auth/validate', true)
          }
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
          throw error
        })
    },
  },
}
</script>
